import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export function usePassportVerifyPageAnalytics() {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.passportVerify) {
      setMktgPageData(
        {
          passport_validation: "1",
        },
        "passportVerify"
      );
    }
  }, [pathname]);
}
